'use client'
import { useEffect, useState } from 'react';
import FooterPage from '@/components/frontend-components/footer/footer';
import Navbar from '@/components/frontend-components/navbar/navbar';
import AuthWrapper from '@/utils/isAuth';
import useHotelBookingStore from '@/lib/useHotelBookingStore';
import { PageActionsProvider } from '@/contexts/PageActionsContext';
import { getPageActions } from '@/constants/data';
import { useRouter } from 'next/navigation';
import useAuthStore from '@/lib/useAuthStore';

function Layout({ children }: { children: React.ReactNode }) {
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const { isErrors }: any = useHotelBookingStore();
  const [pageActions, setPageActions] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const router = useRouter();
  const { logOutUser } = useAuthStore();

  // Check for session expiration
  useEffect(() => {
    const checkSessionExpired = () => {
      const sessionExpired = sessionStorage.getItem('session_expired');
      if (sessionExpired === 'true') {
        // Clear the flag immediately
        sessionStorage.removeItem('session_expired');

        // Handle session expiration
        const handleExpired = async () => {
          try {
            await logOutUser();
          } catch (error) {
            console.error('Error logging out:', error);
            localStorage.removeItem('access_token');
          }

          // Redirect with delay
          setTimeout(() => {
            router.replace('/login?expired=true');
          }, 100);
        };

        handleExpired();
      }
    };

    // Check immediately
    checkSessionExpired();

    // Set up interval to check periodically
    const interval = setInterval(checkSessionExpired, 3000);

    return () => clearInterval(interval);
  }, [router, logOutUser]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 60);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  useEffect(() => {
    async function fetchPageActions() {
      try {
        const actions = await getPageActions();
        setPageActions(actions);
      } catch (error) {
        console.error('Error fetching page actions:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchPageActions();
  }, []);

  // if (loading) {
  //   return <div>Loading...</div>; // Prevent rendering before data is ready
  // }

  return (
    <div className='w-full'>
      <PageActionsProvider pageActions={pageActions?.pageActions || []} user={pageActions?.user || { id: null, role: null }}>
        <AuthWrapper>
          <main className="w-full">
            <div className={`fixed bg-white w-full z-50 transition-transform duration-100 ${visible ? '-translate-y-full' : 'translate-y-0'
              }`}>
              <Navbar />
            </div>
            <div>
              <Navbar />
            </div>

            <div>
              {children}
            </div>
            <FooterPage />
          </main>
        </AuthWrapper>
      </PageActionsProvider>
    </div>
  );
}

export default Layout;